<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel05 from './Jewel05.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel05 ],

    data () {
      return {
        excepts: [ 'あんなコレクション' ],
      }
    },

    computed: {
      itemsPBox () {
        const query = { collection: 'プレゼントボックス' }
        const excepts = [ 'PB-25', 'PB-26', 'PB-27', 'PB-28', 'PB-33', 'PB-34', 'PB-35', 'PB-35:after' ]
        return _
          .where(this.itemsFiltered, query)
          .filter(item => !excepts.includes(item.id))
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR9" />
    </template>

    <template #col2>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col3>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col5>
    </template>

    <template #col6>
    </template>

    <template #col7>
      <ItemList title="すみっコぐらしチャンネル" color="#a1c0fa" :items="itemsSGChannel | first(4)" />
      <ItemList title="おしょうがつチャンネル" color="#a1c0fa" :items="itemsNewYearChannel" />
      <ItemList title="プリティーオールフレンズチャンネル" color="#a1c0fa" :items="itemsPAF" />
    </template>

    <template #col8>
      <ItemList title="冬休み福袋その1 PR ★★★" color="#ffa1bc" :items="itemsLuckyBag1PR" />
      <ItemList title="冬休み福袋その1 SR ★★" color="#00c7da" :items="itemsLuckyBag1SR" />
    </template>

    <template #col9>
      <ItemList title="冬休み福袋その2 PR ★★★" color="#ffa1bc" :items="itemsLuckyBag2PR" />
      <ItemList title="冬休み福袋その2 SR ★★" color="#00c7da" :items="itemsLuckyBag2SR" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // // 4列用カラム内のいちばん左の列に空のアイテムが来ていたら非表示化
  // .Page ::v-deep .Page__col:not(.-narrow) .Item[hidden]:nth-child(4n+1) {
  //   display: none;
  // }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(2) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 50px;
  //   }
  // }
</style>
